export const PROJECT_REPO_URL = "https://github.com/vismaytiwari/serverless_converter";
export const PROJECT_DEMO_URL = "https://vismaytiwari.github.io/serverless_converter/";
